import React, {PropTypes} from 'react';


function GuideIcon(props) {
  const {
    className,
    ...otherProps
  } = props;

  return (
    <svg width='31px' height='30px' viewBox='0 0 31 30' version='1.1' xmlns='http://www.w3.org/2000/svg' className={`profile-icon ${className}`} {...otherProps}>
        <g id='2152---Guide-Icon' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
            <g transform='translate(-127.000000, -113.000000)' id='icon_info' stroke='#4A4A4A'>
                <g transform='translate(128.000000, 114.000000)'>
                    <g id='Icons'>
                        <ellipse id='Oval' strokeWidth='2' cx='14.5' cy='14' rx='14.5' ry='14'></ellipse>
                        <rect id='Rectangle-path' x='12.5666667' y='12.1047897' width='3.5' height='10.2285437'></rect>
                        <circle id='Oval' cx='14.3166667' cy='7.8881392' r='1.75'></circle>
                    </g>
                </g>
            </g>
        </g>
    </svg>
  );
}


GuideIcon.propTypes = {
  className: PropTypes.string
};

export default GuideIcon;



// WEBPACK FOOTER //
// ./shared/common/svgs/GuideIcon/index.js